import { Grid } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Template from "../../template/Template";
import ButtonUpload from "../../components/Buttons/ButtonUpload";
import { useEffect, useState } from "react";
import { apiSpj } from "../../services/api";
import { AlertConfirm, AlertInfo } from "../../components/Alerts/Alert";
import TableData from "../../components/Table/TableData";
import { GridColDef } from "@mui/x-data-grid";
import SimpleBackdrop from "../../components/Loading/Simplebackdrop";
import moment from "moment";
import IconMenu from "../../components/Menu/IconMenu";

type RowsDocsProps = {
    id?: number
    name: string
    atime: string | Date
}

export default function Documentos() {
    const [openLoad, setOpenLoad] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [activeDocument, setActiveDocument] = useState<null | DocumentType>(null);
    const [rows, setRows] = useState([]);
    const columns: GridColDef[] = [
        {
            field: 'name',
            width: 600,
            headerName: 'ARQUIVO',
        },
        {
            field: 'atime',
            width: 200,
            headerName: 'ULTIMA ALTERAÇÃO',
        },
    ];

    function handleClick(doc: any, event: any) {
        setActiveDocument(doc);
        setAnchorEl(event.currentTarget);
    }

    async function downloadDocument() {
        setOpenLoad(true);
        try {
            const name = activeDocument?.name;
            await apiSpj.post(`/downloaddocument`, { name }, { responseType: 'blob' }).then(response => {
                if (response.status === 204) {
                    return AlertInfo({ icon: 'error', title: "Documento não localizado" });
                }
                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.download = `${name}`;
                link.click();
                window.URL.revokeObjectURL(url);
            });
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na conexão' });
        }
        setAnchorEl(null);
        setOpenLoad(false);
    }

    async function deleteDocument() {
        AlertConfirm({ title: 'Deletar Documento?' }).then(async res => {
            if (res.isConfirmed) {
                setOpenLoad(true);
                setAnchorEl(null);
                try {
                    const name = activeDocument?.name;
                    const response = await apiSpj.post(`deletedocument`, { name });
                    if (response && response.status === 200 && response.data) {
                        AlertInfo({ icon: 'success', title: 'Documento Deletado' });
                        loadDocuments();
                    }
                } catch (error) {
                    console.log(error);
                    AlertInfo({ icon: 'error', title: 'Falha na conexão' });
                }
                setOpenLoad(false);
            }
        });
    }

    async function loadDocuments() {
        setOpenLoad(true);
        try {
            const response = await apiSpj.get(`/listdocuments`);
            if (response && response.status === 200 && response.data) {
                const res = response.data;
                const r = res.map((item: RowsDocsProps, index: number) => ({...item, atime: moment(item.atime).format("DD/MM/YYYY HH:mm:ss"), id: index}));
                setRows(r);
            }
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na Conexão' });
        }
        setOpenLoad(false);
    }

    useEffect(() => {
        loadDocuments();
    }, []);

    const arrMenu = [
        { icon: <DownloadIcon fontSize="small" color="primary" />, title: "Baixar Documento", handle: downloadDocument },
        { icon: <DeleteForeverIcon fontSize="small" color="primary" />, title: "Deletar Documento", handle: deleteDocument }
    ];

    return (
        <Template menuActive="Documentos">
            <SimpleBackdrop open={openLoad} />

            <Grid container spacing={1}>
                <Grid size={2}>
                    <ButtonUpload
                        label="UPLOAD"
                        validFile=".docx"
                        route="/adddocument"
                        exeSuccess={loadDocuments}
                    />
                </Grid>

                <Grid size={12}>
                    <TableData
                        rows={rows}
                        columns={columns}
                        handleClick={handleClick}
                        height={500}
                    />
                    <IconMenu
                        anchorEl={anchorEl}
                        setAnchorEl={setAnchorEl}
                        arrMenu={arrMenu}
                    />
                </Grid>
            </Grid>
        </Template>
    );
}